angular.module('iconoglobe')
.factory('AdddressGeoService',['$q', '$http', function($q, $http){
  var baseUrl = window.location.protocol + "//" + window.location.host;
  var get = function(url){
    var deferred= $q.defer();
    $http.get(url)
    .then(function(res){
      var data = res.data;
      if(!data.latitude || !data.longitude){
        deferred.reject("Geolocation no available for Address");
      } else {
        deferred.resolve(data);
      }
    }, function(error){
      deferred.reject("Geolocation no available for Address");
    });
    return deferred.promise;
  };
 
  return {
    get : get
  };
}]);